import { QueryModelCore } from "@/core/model.core";

export default class Admin {
  /**
   * 获取字典列表
   * @param {string} dicName 字典名称
   */
  async getDicList(dicName) {
    const result = await new QueryModelCore('/api-admin/app/sysDic/listDicDesc').get({ dicName });
    const { dataMap } = result;
    return dataMap;
  }

  // 报名登录
  async signupLogin(params) {
    const result = await new QueryModelCore('/api-admin/companyQF/apply/login').post(params);
    const { dataMap } = result;
    return dataMap;
  }

  async getRule(params) {
    const result = await new QueryModelCore('/api-admin/sysConfigApp/query').get(params);
    const { dataMap } = result;
    return dataMap;
  }

  // dify聊天历史记录
  async getChatHistory(params) {
    const result = await new QueryModelCore('/api-api/dify/chatHistory').get(params);
    const { dataMap } = result;
    return dataMap;
  }

  // dify聊天详情
  async getHistoryByConversationId(params) {
    const result = await new QueryModelCore('/api-api/dify/chatHistoryByConversationId').get(params);
    const { dataMap } = result;
    return dataMap;
  }

  // dify获取产品推荐
  async getProductRecommend(params) {
    const result = await new QueryModelCore('/api-api/dify/getProductRecommend').get(params);
    const { dataMap } = result;
    return dataMap;
  }

  // dify消息操作
  async updatemessageOperate(params) {
    const result = await new QueryModelCore('/api-api/dify/messageOperate').post(params);
    const { dataMap } = result;
    return dataMap;
  }
}